import {defineStore} from 'pinia'

export const useProgressBarsStore = defineStore('progressBars', {
    state: () => {
        return {
            saveProgressBar: false,
        }
    },
    actions: {

        getSaveProgressBar() {
            return this.saveProgressBar;
        },
        setSaveProgressBar(saveProgressBar) {
            this.saveProgressBar = saveProgressBar
        }

    },
    getters: {}

})
